// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"e554f43a","607":"da7b117a","793":"22381f04"}[chunkId] + ".chunk.js";
};